/* eslint-disable require-jsdoc */
/* eslint-disable no-undef */

// import {debug} from '../../config';
import { debug } from '../../../../config';
import {getFetchOpts, json, status} from './fetchLogic';

async function getFetch(hearbyApiKey, url, auth) {
 debug && console.log('in fetch');
  const opts = getFetchOpts(hearbyApiKey, 'GET', auth);
  let result;
  await fetch(url, opts)
      .then(status)
      .then(json)
      .then((data) => {
        debug && console.log('events ', data);
        result = data;
      }).catch(function(error) {
        debug && console.log('Request failed', error);
      });
  return result;
}
async function postFetch(hearbyApiKey, url, auth) {
  let result;
  const fullUrl = config.pApiDevBase + url;
  const opts = getOpts(hearbyApiKey,'POST', auth);
  await fetch(fullUrl, opts)
      .then(status)
      .then(json)
      .then(function(data) {
        result = data;
      }).catch(function(error) {
        debug && console.log('Request failed', error);
      });
  return result;
}
export {getFetch, postFetch};
